<div class="ui-g-12 text-left no-padding">
	<app-file-progress
		*ngIf="progressVisible"
		[message]="progressMessage"
		[mode]="progressMode"
		[progress] = "progressAmount">
	</app-file-progress>

	<div *ngIf="showDownload"
		class="ui-g-12 nested-display-subtitle text-left">
		<span class="nested-display-actions">
			<ng-template
				ngFor
				let-action
				[ngForOf]="itemActions">
				<span [ngClass]="{
						'selected-bottom-border': (action.id === 'download')
					}">
					<app-common-icon-tooltip
						content="{{action.label}}"
						iconClass="fa fa-fw {{action.icon}} theme-color"
						[ngClass]="{
							'cursor-pointer': !action.disabled,
							'disabled': action.disabled
						}"
						position="left"
						styleClass="utility-menu-tooltip"
						[allowTooltipActivation]="!action.disabled"
						[pTooltip]="action.disabled ? action.title : ''"
						tooltipPosition="left"
						tooltipStyleClass="utility-menu-tooltip"
						(iconClick)="action.command($event)">
					</app-common-icon-tooltip>
				</span>
			</ng-template>
		</span>

		<div class="ellipsis-text-2-line"
			[pTooltip]="fileEntity.data.name"
			tooltipPosition="left"
			tooltipStyleClass="utility-menu-tooltip">
			Download:
			<strong style="font-size: smaller">
				&nbsp;{{fileEntity.data.name}}
			</strong>
		</div>
	</div>

	<div class="ui-g-12 no-padding text-right button-set">
		<span
			class="inline-block-display"
			[pTooltip]="!fileAvailable ? fileUnavailableMessage : ''"
			tooltipPosition="top">
			<button
				pButton
				label="Open"
				class="pi-button-secondary"
				[disabled]="!fileAvailable"
				aria-hidden="true"
				(click)="onOpenClicked()">
			</button>
		</span>
		<span
			class="inline-block-display"
			[pTooltip]="!fileAvailable ? fileUnavailableMessage : ''"
			tooltipPosition="top">
			<button
				pButton
				label="Download"
				[disabled]="!fileAvailable"
				aria-hidden="true"
				(click)="onSaveClicked()">
			</button>
		</span>
		<span
			class="inline-block-display"
			[pTooltip]="!fileAvailable ? fileUnavailableMessage : ''"
			tooltipPosition="top">
			<button
				pButton
				label="Print"
				class="no-margin-right primary-action-button"
				[disabled]="!fileAvailable"
				aria-hidden="true"
				(click)="onPrintClicked()">
			</button>
		</span>
	</div>
</div>